import React, { useEffect, useState } from "react";
import { serviceRequestsActions, useDispatch, useSelector } from "../../state";
import { serviceRequestsSelectors } from "../../state/serviceRequests/selectors";
import { authSelectors } from "../../state/auth/selectors";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { SERVICE_REQUEST_COLUMNS as columns } from "../../constants/tables";
import { Typography } from "@mui/material";

export default function ServiceRequestsPage() {
  const dispatch = useDispatch();
  // get role and active agency id
  const role = useSelector(authSelectors.activeRole);
  const activeAgencyId = useSelector(authSelectors.activeAgencyId);
  const serviceRequests = useSelector(serviceRequestsSelectors.serviceRequests);
  const [pageSize, setPageSize] = useState(25);
  useEffect(() => {
    dispatch(serviceRequestsActions.getServiceRequests(role, activeAgencyId));
  }, [dispatch, role, activeAgencyId]);


  return (
    <div>
      <Typography variant="h1" sx={{ fontSize: 20, fontWeight: 600, my: 1 }}>
        Service Requests
      </Typography>
      <DataGridPro
        autoHeight
        rows={serviceRequests}
        columns={columns}
        rowsPerPageOptions={[10, 25, 50, 100, 250]}
        pageSize={pageSize}
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        pagination
      />
    </div>
  );
}
